function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Polygon_86",
  "data-name": "Polygon 86",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.378,4.72a3,3,0,0,1,5.245,0l14.9,26.823A3,3,0,0,1,34.9,36H5.1a3,3,0,0,1-2.622-4.457Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 19.99999809265137 5.177379608154297 C 19.82307815551758 5.177379608154297 19.38374900817871 5.227500915527344 19.1258373260498 5.691741943359375 L 4.224388122558594 32.51435089111328 C 3.973728179931641 32.96554183959961 4.149478912353516 33.35894012451172 4.236679077148438 33.50712966918945 C 4.323867797851562 33.65531921386719 4.5823974609375 34 5.098537445068359 34 L 34.90145874023438 34 C 35.41759872436523 34 35.67612838745117 33.65531921386719 35.7633171081543 33.50712966918945 C 35.85051727294922 33.35894012451172 36.02626800537109 32.96554183959961 35.77561950683594 32.51435852050781 L 20.87414741516113 5.691730499267578 C 20.61624717712402 5.227500915527344 20.17691802978516 5.177379608154297 19.99999809265137 5.177379608154297 M 19.99999809265137 3.177379608154297 C 21.02548027038574 3.177379608154297 22.05096244812012 3.691734313964844 22.62246894836426 4.720451354980469 L 37.52392959594727 31.54306983947754 C 38.63480758666992 33.54265975952148 37.18890762329102 36 34.90145874023438 36 L 5.098537445068359 36 C 2.811088562011719 36 1.365188598632812 33.54265975952148 2.476066589355469 31.54306983947754 L 17.37752723693848 4.720451354980469 C 17.94903373718262 3.691734313964844 18.97451591491699 3.177379608154297 19.99999809265137 3.177379608154297 Z",
  stroke: "none",
  fill: "#fff"
}));

var _ref3 = /*#__PURE__*/React.createElement("line", {
  id: "Line_288",
  "data-name": "Line 288",
  y2: 8,
  transform: "translate(20 14)",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 3
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_6",
  "data-name": "Ellipse 6",
  cx: 2,
  cy: 2,
  r: 2,
  transform: "translate(18 27.131)",
  fill: "#fff"
});

function SvgIconAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconAlert",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlert);
export default __webpack_public_path__ + "static/media/iconAlert.6268f6f9.svg";
export { ForwardRef as ReactComponent };